module.exports = __webpack_public_path__ + "media/elevadizo/buque-dd-ap-28a9a3ff.png";